import { BlockTitle } from '@/components/old';

import { SERVICE_CODES } from '@/lib/consts';

import { getAccordionsText } from '@/api/apiService';

import Accordion from '../../../../../../components/Accordion/Accordion';
import { Loader } from '@/shared/ui';
import { StepsNavigationName } from '../../../../../../config/services';
import { useAsyncDataLoader } from '../../../../../../hooks/useAsyncDataLoader';
import { useAsyncEffect } from '../../../../../../hooks/useAsyncEffect';

const Step1: React.FC = () => {
  const { isLoading: isTextLoading, data: accordionsText, load: loadText } = useAsyncDataLoader(getAccordionsText);

  useAsyncEffect(loadText, []);

  if (isTextLoading) {
    return <Loader centered />;
  }

  return (
    <>
      <BlockTitle id="step-description" paddingBottomMdExtra bgLight>
        {StepsNavigationName.serviceDescription}
      </BlockTitle>
      <Accordion
        accordionData={
          (accordionsText &&
            accordionsText[SERVICE_CODES.STORAGE_CARRYING].map(
              (value) =>
                ({
                  title: <div dangerouslySetInnerHTML={{ __html: value.title }}></div>,
                  content: <div dangerouslySetInnerHTML={{ __html: value.content }}></div>,
                }) as any,
            )) ||
          []
        }
      />
    </>
  );
};

export default Step1;
